import { Typography, CardContent, CardMedia, Box } from "@mui/material";
import {
  descriptionStyles,
  imageWrapperStyles,
  productCardContentStyles,
} from "./styles";

interface IProps {
  product: ICartProduct;
}

const ProductCard: React.FC<IProps> = ({ product }) => {
  const { name, price, image, type, quantity } = product;
  return (
    <Box display="flex" width={"100%"} gap={{ xs: 2, lg: 3 }}>
      {/* Image */}
      <Box sx={imageWrapperStyles}>
        <CardMedia
          component="img"
          image={image}
          alt={name}
          sx={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </Box>

      {/* Description */}
      <CardContent sx={productCardContentStyles}>
        <Box sx={descriptionStyles}>
          <Typography
            fontSize={{ xs: 18, sm: 24 }}
            variant="h4"
            component="h3"
            color="text.primary"
            mb={{ xs: 1, md: 1.5 }}
          >
            {type === "plan" ? (
              <>
                {name}.{" "}
                <Typography
                  fontSize="inherit !important"
                  fontFamily="inherit !important"
                  color="inherit"
                  variant="body1"
                  component="span"
                >
                  Subscription
                </Typography>
              </>
            ) : (
                name
            )}
          </Typography>

          <Typography fontWeight={{ xs: 500, md: 600 }} color="text.primary">
            Quantity: {quantity}
          </Typography>
        </Box>

        {/* Price */}
        <Typography
          variant="h4"
          color="text.primary"
          component="p"
          fontWeight={700}
        >
          ${price}
        </Typography>
      </CardContent>
    </Box>
  );
};

export default ProductCard;
